import React from "react";
import { withRouter } from "react-router";
import { withTranslation } from "react-i18next";
import classNames from "classnames";
import "./index.scss";

import RadioButtons from "../RadioButtons";
import ColumnTitleWithIcon from "../ColumnTitleWithIcon";

const SectionItemPaymeRadioButtons = ({
    t,
    column, item, value, 
    onPropChange
}) => {    
    const handleOnChange = val => {
        if(column.isReadonly){
            return;
        }

        const isTrue = String(val.value) === "true";
        const isSubindex = !isNaN(parseInt(val.subItemIndex));     
        let newVal = {
            value: isSubindex 
                ? value.value
                : (isTrue ? val.item.value : null)
        }

        if(isTrue) {
            if(isSubindex) {
                newVal.selected = val.item.items
                    ? value.selected.concat(val.item.items[val.subItemIndex].value)
                    : value.selected
            } else {
                newVal.selected = value.selected;
            }            
        } else {
            newVal.selected = isSubindex
                ? value.selected.filter(f=> f !== val.item.items[val.subItemIndex].value)
                : [];
        }
        
        onPropChange({ [column.accessor]: newVal });
    }

    return (
        <div className={classNames("sectionItem", "sectionItemRadioButtons")}>
            <ColumnTitleWithIcon item={item} column={column} onPropChange={onPropChange} />
            <RadioButtons items={column.values} value={value} 
                onChange={handleOnChange} 
            />
            {item && value && value.selected && value.selected.includes("acceptCreditCard") && (
                <div className={classNames("info", "inline")}>
                    {item.paymeWalletExist && (
                        <span>
                            <span>*&nbsp;{t("settings.paymeWallet.CREDIT_ACCEPT_READY")}:&nbsp;</span>
                            {!!item.paymeWalletSignupUrl && (
                                <a href={item.paymeWalletSignupUrl}>
                                    {item.paymeWalletSignupUrl}
                                </a>
                            )}
                            {!item.paymeWalletSignupUrl && (<span>{t("settings.paymeWallet.PAYME_WALLET_SIGNUO_URL")}</span>)}
                        </span>
                    )}
                </div>
            )}
        </div>
    )
};

export default withRouter(
    withTranslation()(SectionItemPaymeRadioButtons)
);